"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveBonusMaxBet = void 0;
var profile_api_1 = require("@l2p/profile-api");
var react_1 = require("react");
var bonuses_1 = require("../bonuses");
var currencies_1 = require("../currencies");
var useActiveBonusMaxBet = function () {
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var bonuses = (0, bonuses_1.useBonuses)(currentCurrency).data;
    var activeBonus = (0, react_1.useMemo)(function () { return bonuses === null || bonuses === void 0 ? void 0 : bonuses.find(function (bonus) { return bonus.status === profile_api_1.BonusCardStatus.InProgress; }); }, [bonuses]);
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        var maxBetData = (_b = (_a = activeBonus === null || activeBonus === void 0 ? void 0 : activeBonus.bonus) === null || _a === void 0 ? void 0 : _a.constraints) === null || _b === void 0 ? void 0 : _b.find(function (r) { return r.type === 'MAX_BET'; });
        var maxBet = (_c = maxBetData === null || maxBetData === void 0 ? void 0 : maxBetData.maxBet) === null || _c === void 0 ? void 0 : _c.find(function (r) { return r.currency === currentCurrency; });
        var maxBetAmount = maxBet === null || maxBet === void 0 ? void 0 : maxBet.amount;
        if (!maxBetAmount)
            return null;
        return {
            amount: Number(maxBetAmount),
            currency: currentCurrency,
        };
    }, [currentCurrency, activeBonus]);
};
exports.useActiveBonusMaxBet = useActiveBonusMaxBet;
